import React from 'react';
import { EyeIcon, MessageCircleIcon, ZapIcon, CrosshairIcon } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    icon: <EyeIcon className="w-8 h-8 text-gold" data-id="element-164" />,
    title: 'Lectura de Lenguaje Corporal',
    desc: 'Aprende a leer el lenguaje no verbal para saber exactamente cuándo hay interés real y cuándo es momento de avanzar.'
  }, {
    icon: <MessageCircleIcon className="w-8 h-8 text-gold" data-id="element-165" />,
    title: 'El Poder del Silencio',
    desc: 'Cómo usar las pausas y el silencio para generar curiosidad, tensión social e intriga en cualquier conversación.'
  }, {
    icon: <ZapIcon className="w-8 h-8 text-gold" data-id="element-166" />,
    title: 'Carisma Digital',
    desc: 'El truco psicológico para que tu mensaje de WhatsApp sea el que ella responda primero entre todos los demás.'
  }, {
    icon: <CrosshairIcon className="w-8 h-8 text-gold" data-id="element-167" />,
    title: 'Posicionamiento de Alto Valor',
    desc: 'Dinámicas de atracción para entrar a círculos sociales nuevos y que tu presencia sea respetada de inmediato.'
  }];
  const scrollToTestimonials = () => {
    document.getElementById('testimonials-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 bg-surface-card relative border-y border-surface-border" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="text-center mb-10" data-id="element-170">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-171">
            La ciencia detrás de los{' '}
            <span className="text-gold italic" data-id="element-172">Trucos</span> Sociales
          </h2>
          <p className="font-body text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-173">
            El carisma no se nace, se construye. Consta de 17{' '}
            <span className="text-gold italic" data-id="element-174">trucos</span> mecánicos y
            psicológicos que transforman tu energía y cómo te percibe el mundo.
            No tienes que cambiar tu personalidad, solo ajustar ciertos
            patrones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-175">
          {benefits.map((benefit, index) => <div key={index} className="bg-surface-deepest p-8 rounded-2xl border border-surface-border hover:border-gold/40 transition-all duration-300 group" data-id="element-176">
              <div className="mb-6 bg-surface-elevated w-16 h-16 rounded-xl flex items-center justify-center border border-gold/20 group-hover:scale-110 transition-transform duration-300" data-id="element-177">
                {benefit.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-3" data-id="element-178">
                {benefit.title}
              </h3>
              <p className="font-body text-sm text-gray-400 leading-relaxed" data-id="element-179">
                {benefit.desc}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-180">
          <button onClick={scrollToTestimonials} className="px-10 py-5 bg-red-600 hover:bg-red-700 text-white font-body font-bold text-lg rounded-xl transition-all duration-300 animate-heartbeat animate-pulse-red shadow-lg shadow-red-600/20" data-id="element-181">
            SÍ, QUIERO SER MÁS CARISMÁTICO
          </button>
        </div>
      </div>
    </section>;
}